import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import lightningIcon from '../../../../assets/images/partnership/icons/Lightning.svg';
import walletIcon from '../../../../assets/images/partnership/icons/Wallet.svg';
import pathIcon from '../../../../assets/images/partnership/icons/Path.svg';
import trendingUpIcon from '../../../../assets/images/partnership/icons/trending-up.svg';
import './Consistency.css';

const features = [
  {
    title: 'Superior Execution Standards',
    text: 'Our technology ecosystem is built to support fast, efficient execution and a seamless client experience.',
    icon: lightningIcon,
  },
  {
    title: 'Flexible Compensation Models',
    text: 'Transparent compensation structures aligned with your business goals and long-term growth potential.',
    icon: walletIcon,
  },
  {
    title: 'Streamlined Onboarding',
    text: 'A guided onboarding journey supported by our team — enabling a smooth and quick start.',
    icon: pathIcon,
  },
  {
    title: 'Consistent Passive Revenue',
    text: 'Generate recurring income through partner referrals and ongoing client activity under clear terms.',
    icon: trendingUpIcon,
  },
];

const Consistency = () => {
  return (
    <section className="consistency">
      <div className="consistency__inner">
        <Reveal className="consistency__header">
          <h2 className="consistency__title">
            A Partner Experience Designed for Consistency.
          </h2>
        </Reveal>

        <div className="consistency__grid">
          {features.map(({ title, text, icon }, index) => (
            <Reveal key={title} delay={index * 80}>
              <article className="consistency__card">
                <div className="consistency__icon">
                  <img src={icon} alt="" aria-hidden="true" />
                </div>
                <h3 className="consistency__card-title">{title}</h3>
                <p className="consistency__card-text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Consistency;
